import { Component } from 'vue-property-decorator';
import IssueItemBaseMixin from '@/components/ViewComponent/Issue/IssueItem/issue-item-base.mixin';
import { StaffEntity } from '@/entities/staff.entity';
import { CSelectButtonsPropsItems } from '@/components/Helper/Form/CSelectButtons.vue';
import { mapState } from 'vuex';
import IssueService, { ResolveIssueEntity } from '@/services/issue.service';
import { UseService } from '@/services/service';

@Component<BtnResolveIssueMixin>({
  computed: {
    ...mapState('staff', ['current']),
  },
})
export default class BtnResolveIssueMixin extends IssueItemBaseMixin {
  dialog = false;

  @UseService(IssueService)
  service: IssueService;

  current!: StaffEntity;

  resolveData: ResolveIssueEntity = {
    issueId: null,
    message: null,
  };

  created() {
    this.resolveData.issueId = this.issue.id;
  }

  get pointOptionList(): CSelectButtonsPropsItems[] {
    return this.current.defaultGiftPoint.map((pt) => ({
      value: pt,
      text: `${pt}pt`,
    }));
  }

  async resolve() {
    await this.service.resolve(this.resolveData);
    this.dialog = false;
  }
}
